export default __webpack_public_path__ + "files/thumbnail-0f6c377c1bbcdd1f4c0c9bc12be47fd5.png";